<template>
  <modal-template
    ref="modal"
    modal-size="sm"
    :title="title"
    :type-modal="modalName"
  >
    <div class="modal-content__main">
      <d-form @submit="send()">
        <d-form-row>
          <!-- Message -->
          <d-col md="12">
            <p v-html="message"></p>
          </d-col>
        </d-form-row>
      </d-form>
    </div>

    <div slot="actions" class="modal-content__control">
      <d-button
        type="button"
        @click="onCancel()"
        class="btn btn-sm btn-secondary mr-4"
      >
        {{ cancelLabel }}
      </d-button>
      <d-button
        type="button"
        @click="onConfirm()"
        class="btn btn-sm btn-primary"
      >
        {{ confirmLabel }}
      </d-button>
    </div>
  </modal-template>
</template>

<script>
import { mapActions } from 'vuex';
import ModalTemplate from '_shared/Modal.vue';

export default {
  name: 'confirmation-modal',
  props: {
    modalName: {
      type: String,
      default: 'confirm_modal',
    },
    message: {
      type: String,
      default: 'Tem certeza que deseja excluir',
    },
    title: {
      type: String,
      default: 'Confirmar exclusão',
    },
    cancelLabel: {
      type: String,
      default: 'Cancelar',
    },
    confirmLabel: {
      type: String,
      default: 'Confirmar',
    },
    confirm: {
      type: Function,
      default: () => {},
    },
    cancel: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  components: {
    ModalTemplate,
  },
  methods: {
    ...mapActions(['setToggle']),
    onCancel() {
      this.cancel();
    },
    onConfirm() {
      this.confirm();
    },
  },
};
</script>
<style lang="scss">
@media (min-width: 992px) {
  .modal-sm {
    max-width: 550px;
  }
}
</style>
<style lang="scss" scoped>
.modal-sm {
  p {
    margin-bottom: 0;
  }
}
.modal-content__control {
  display: flex;
  justify-content: flex-end;
}
</style>
